// Centralised image URLs for academic-style music photography
// All usage is purely illustrative on the front-end (no external calls beyond standard image loading).

export const IMAGE_SOURCES = {
  // About page
  aboutLesson: "https://images.unsplash.com/photo-1696522732406-065ef560da8c",

  // Teachers & Educators
  teachersLesson: "https://images.unsplash.com/photo-1519076976365-9c64dbd98317",
  teachersSheetMusic: "https://images.unsplash.com/photo-1599866193011-348f9eb29868",

  // Teacher Resources
  resourcesSheetViolin: "https://images.unsplash.com/photo-1568057609581-8556cf900d3c",
  resourcesNotes: "https://images.unsplash.com/photo-1591025810539-a321000cda85",

  // Examination System
  examPianoStudent: "https://images.unsplash.com/photo-1552422535-c45813c61732",

  // Instrument detail pages
  pianoDetail: "https://images.unsplash.com/photo-1520523839897-bd0b52f945a0",
  guitarDetail: "https://images.unsplash.com/photo-1511379938547-c1f69419868d",
  violinDetail: "https://images.unsplash.com/photo-1525072124541-6237cc6b85a0",
  drumsDetail: "https://images.unsplash.com/photo-1519861531473-9200262188bf",
  vocalsDetail: "https://images.unsplash.com/photo-1525286116112-b59af11adad1",

  // Examiner Panel
  examinerSheet: "https://images.unsplash.com/photo-1717699841805-e80424b1be43",
  examinerNotes: "https://images.unsplash.com/photo-1632234032819-fe390001b9b0",

  // Certification & Recognition
  certificationPiano: "https://images.unsplash.com/photo-1520523839897-bd0b52f945a0",
  certificationSheet: "https://images.unsplash.com/photo-1512733596533-7b00ccf8ebaf",

  // Contact & Support
  contactDesk: "https://images.pexels.com/photos/164821/pexels-photo-164821.jpeg",
};
